import { ref, get, query, orderByChild, equalTo } from "firebase/database";
import { db } from "../firebaseConfig";
import { ReturnItemData } from "../../models/credit";

export const getReturnedItemsByInvoiceNumber = async (
	invoiceNumber: string
): Promise<ReturnItemData[]> => {
	const creditsRef = ref(db, "returns");
	const creditsQuery = query(
		creditsRef,
		orderByChild("invoiceNumber"),
		equalTo(invoiceNumber)
	);
	const snapshot = await get(creditsQuery);
	const returned: ReturnItemData[] = [];
	if (snapshot.exists()) {
		snapshot.forEach((child) => {
			returned.push(child.val());
		});
	}
	return returned;
};
